(() => {
  const standardSizes = new Set(['50x70', '60x70', '75x70', '78x78', '85x75']);
  document.querySelectorAll('[data-kk-waf-mini]').forEach((root) => {
    const width = root.querySelector('[data-kk-waf-mini-width]');
    const depth = root.querySelector('[data-kk-waf-mini-depth]');
    const widthNumber = root.querySelector('[data-kk-waf-mini-width-number]');
    const depthNumber = root.querySelector('[data-kk-waf-mini-depth-number]');
    const widthOutput = root.querySelector('[data-kk-waf-mini-width-output]');
    const depthOutput = root.querySelector('[data-kk-waf-mini-depth-output]');
    const sizeOutput = root.querySelector('[data-kk-waf-mini-size-label]');
    const selectionOutput = root.querySelector('[data-kk-waf-mini-selection]');
    const continueLink = root.querySelector('[data-kk-waf-mini-continue]');
    const outerPath = root.querySelector('[data-kk-waf-svg-outer]');
    const innerPath = root.querySelector('[data-kk-waf-svg-inner]');
    const widthLine = root.querySelector('[data-kk-waf-svg-width-line]');
    const depthLine = root.querySelector('[data-kk-waf-svg-depth-line]');
    const widthLabel = root.querySelector('[data-kk-waf-svg-width-label]');
    const depthLabel = root.querySelector('[data-kk-waf-svg-depth-label]');
    const sizeButtons = [...root.querySelectorAll('[data-kk-waf-mini-size]')];
    if (!width || !depth || !continueLink || !outerPath || !innerPath) return;

    const clamp = (value, input) => Math.min(Number(input.max), Math.max(Number(input.min), Math.round(Number(value))));
    const updateGraphic = (w, d) => {
      const scale = Math.min(126 / w, 96 / d);
      const shapeWidth = w * scale;
      const shapeHeight = d * scale;
      const left = 100 - shapeWidth / 2;
      const right = 100 + shapeWidth / 2;
      const top = 71 - shapeHeight / 2;
      const bottom = 71 + shapeHeight / 2;
      const radius = Math.min(5, shapeWidth * .12, shapeHeight * .08);
      const inset = Math.min(18, shapeWidth * .22, shapeHeight * .24);
      const innerLeft = left + inset;
      const innerRight = right - inset;
      const innerTop = top + inset;
      outerPath.setAttribute('d', `M ${left + radius} ${top} L ${right - radius} ${top} Q ${right} ${top} ${right} ${top + radius} L ${right} ${bottom - radius} Q ${right} ${bottom} ${right - radius} ${bottom} L ${left + radius} ${bottom} Q ${left} ${bottom} ${left} ${bottom - radius} L ${left} ${top + radius} Q ${left} ${top} ${left + radius} ${top} Z`);
      innerPath.setAttribute('d', `M ${innerLeft} ${innerTop} L ${innerLeft} ${bottom - inset / 2} M ${innerLeft} ${innerTop} L ${innerRight} ${innerTop} L ${innerRight} ${bottom - inset / 2}`);
      widthLine?.setAttribute('d', `M ${left} ${bottom + 7} L ${right} ${bottom + 7}`);
      depthLine?.setAttribute('d', `M ${left - 8} ${top} L ${left - 8} ${bottom}`);
      if (widthLabel) { widthLabel.textContent = `${w} cm`; widthLabel.setAttribute('x', '100'); widthLabel.setAttribute('y', `${bottom + 17}`); }
      if (depthLabel) { depthLabel.textContent = `${d} cm`; depthLabel.setAttribute('x', `${left - 15}`); depthLabel.setAttribute('y', `${(top + bottom) / 2}`); depthLabel.setAttribute('transform', `rotate(-90 ${left - 15} ${(top + bottom) / 2})`); }
    };
    const update = ({ updateUrl = true } = {}) => {
      const w = Number(width.value), d = Number(depth.value);
      [widthNumber, depthNumber].forEach((input, index) => { if (input) input.value = String(index === 0 ? w : d); });
      if (widthOutput) widthOutput.textContent = `${w} cm`;
      if (depthOutput) depthOutput.textContent = `${d} cm`;
      if (sizeOutput) sizeOutput.textContent = `${w} × ${d} cm`;
      if (selectionOutput) selectionOutput.textContent = `${w} × ${d} cm`;
      updateGraphic(w, d);
      const exactSize = `${w}x${d}`;
      sizeButtons.forEach((button) => {
        const selected = Number(button.dataset.width) === w && Number(button.dataset.depth) === d;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      try { sessionStorage.setItem('kkWafMiniSelection', JSON.stringify({ width: w, depth: d, exactStandardSize: standardSizes.has(exactSize) })); } catch (error) { /* Storage can be unavailable in private browsing. */ }
      if (updateUrl) {
        const target = new URL(root.dataset.kkWafMiniLargeUrl || continueLink.href, window.location.origin);
        target.searchParams.set('kk_mini_width', String(w));
        target.searchParams.set('kk_mini_depth', String(d));
        continueLink.href = target.toString();
      }
    };
    const bindNumberInput = (input, rangeInput) => {
      if (!input) return;
      input.addEventListener('input', () => {
        if (input.value === '' || !Number.isInteger(Number(input.value))) return;
        const value = Number(input.value);
        if (value < Number(rangeInput.min) || value > Number(rangeInput.max)) return;
        rangeInput.value = String(value);
        update();
      });
      input.addEventListener('change', () => {
        if (input.value === '' || !Number.isInteger(Number(input.value))) input.value = rangeInput.value;
        const value = clamp(input.value, rangeInput);
        input.value = String(value);
        rangeInput.value = String(value);
        update();
      });
    };

    width.addEventListener('input', () => update());
    depth.addEventListener('input', () => update());
    bindNumberInput(widthNumber, width);
    bindNumberInput(depthNumber, depth);
    sizeButtons.forEach((button) => button.addEventListener('click', () => {
      width.value = button.dataset.width;
      depth.value = button.dataset.depth;
      update();
    }));

    const params = new URLSearchParams(window.location.search);
    const incomingWidth = params.get('kk_mini_width');
    const incomingDepth = params.get('kk_mini_depth');
    if (incomingWidth && incomingDepth && /^\d+$/.test(incomingWidth) && /^\d+$/.test(incomingDepth)) {
      width.value = String(clamp(incomingWidth, width));
      depth.value = String(clamp(incomingDepth, depth));
    }
    update();
  });
})();
